import React from 'react';
import { DISPLAY_CONFIG } from '../config/display';
import whiteoutLogo from '../assets/whiteout-logo.png';

interface Props {
  children: React.ReactNode;
  /** Defaults to reloading the page (or the app's web view). */
  onReload?: () => void;
}
interface State { failed: boolean; }

/**
 * Last line of defence: a render error anywhere below shows a way back
 * instead of an empty screen (which on iOS looks like a crashed app).
 */
export default class ErrorBoundary extends React.Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Unexpected error in the app', error, info.componentStack);
  }

  private reload = () => {
    if (this.props.onReload) this.props.onReload();
    else window.location.reload();
  };

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="loading-screen error-screen" role="alert">
        <div className="loading-lockup">
          <img src={whiteoutLogo} alt="" aria-hidden="true" />
          <div className="loading-logo">{DISPLAY_CONFIG.brandName}</div>
        </div>
        <h1>Something went wrong</h1>
        <p>Any wager already placed is still running on the server. Reload to get back on the slope.</p>
        <button type="button" className="btn-settings" onClick={this.reload}>Reload</button>
      </main>
    );
  }
}
